import { FC } from "react";
import { Sort } from "../../entities/sort";
import styles from "./catalogue-selected-tags.module.css";
import { useAppNavigate, useAppSearchParams } from "@commons-monorepo/index";

interface CatalogueSelectedTagsProps {}

const CatalogueSelectedTags: FC<CatalogueSelectedTagsProps> = () => {
  const [searchParams] = useAppSearchParams();
  let selectedCategories = searchParams.get("categories")?.split("|") || [];
  const navigate = useAppNavigate();

  const handleClickCategoryTag = (category: string): void => {
    selectedCategories = selectedCategories.filter((c) => c !== category);
    if (selectedCategories.length === 0) {
      navigate("");
    } else {
      navigate(`?page=1&categories=${selectedCategories.join("|")}`, {
        preventScrollReset: true
      });
    }
  };

  const handleClickSortTag = (sort: Sort): void => {};

  return !!selectedCategories.length ?
  <div className={styles.catalogueSelectedTags}>
      <div className={styles.tags}>
        {selectedCategories.map((c) =>
      <button
        key={`catalogue-selected-tag-${c}`}
        className={styles.tag}
        onClick={() => handleClickCategoryTag(c)}>

            <span className={styles.text}>{c.replace("@", " - ")}</span>
            <div className={styles.close}>
              <span className={`${styles.iconClose} icon-close`} />
            </div>
          </button>
      )}
        {/*TODO: Revisar el toggle de sorts
        {selectedSorts.map((s) => (
         <button
           key={`catalogue-selected-tag-${s.id}`}
           className={styles.tag}
           onClick={() => handleClickSortTag(s)}
         >
           <span className={styles.text}>
             {t(`sort_filters_modal.modal_sort.sort-item-${s.value}`)}
           </span>
           <div className={styles.close}>
             <span className={`${styles.iconClose} icon-close`} />
           </div>
         </button>
        ))}*/}
      </div>
    </div> :
  null;
};

export default CatalogueSelectedTags;